import { getImageDimensions } from './getImageDimensions';

import { ErrorCode } from '../form/sharedComponents/ImageUpload';

export const MULTI_NUM_IMAGES = 4;
export const MAX_IMAGE_MB = 16;
export const MAX_IMAGE_SIZE = MAX_IMAGE_MB * 1024 * 1024; // 16MB;
export const MIN_DIMENSIONS = {
    height: 768,
    width: 768,
};

export const imageUploadValidator = async (acceptedFiles: File[]): Promise<ErrorCode[]> => {
    const errorCodes: ErrorCode[] = [];

    const acceptedFilesDimensions = await Promise.all(
        acceptedFiles.map(async file => await getImageDimensions(file))
    );

    const minDimensionsError = acceptedFilesDimensions.some(
        file => file.height < MIN_DIMENSIONS.height || file.width < MIN_DIMENSIONS.width
    );

    if (minDimensionsError) {
        errorCodes.push('invalid-dimensions');
    }

    return errorCodes;
};
